module.exports = __webpack_public_path__ + "static/media/ICT4U.8f7c825c.jpg";